import { Component } from '@angular/core';
import { ViewChild, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../../service/root.service';

import { User } from '../shared/user';
import { UserService } from '../shared/user.service';

import { ConfirmationService } from 'primeng/primeng';

@Component({

    selector: 'user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit, OnDestroy {
    @Input() user: User;
    @Input() id: number;
    @Input() operation: string;
    roles: any;
  
    @ViewChild('formElement') formElement;
    @ViewChild('form') form;
    @Output() formSubmited = new EventEmitter();

    fromRoute: boolean;

    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;
    submittingForm: boolean = false;


    constructor(public rootService: RootService,
        public userService: UserService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) {



    }
    ngOnChanges() {
        if (this.operation == 'read' || this.operation == 'update') {
            if (typeof this.id !== 'undefined') {
                this.getUser(+this.id);
            }
        } else {
            if (typeof this.id !== 'undefined') {
                this.refreshRequest();
            }

        }
    }
    getUser(id: number) {
        this.user = null;
        this.requestError = false;
        this.noResult = false;
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        this.requestXHR = this.userService.get(id)
            .subscribe(
            items => {
                if (items.users && items.users.length > 0) {
                    this.user = items.users[0];
                } else {
                    this.noResult = true;
                }
                this.roles= items.roles;
  


            }, //Bind to view
            err => {
                this.requestError = true;
                // Log errors if any
                this.rootService.toast.showErrorCode(err.code);
            });
    }
    getClone(id: number) {
        this.user = null;
        this.requestError = false;
        this.noResult = false;
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        this.requestXHR = this.userService.getClone(id)
            .subscribe(
            items => {

                if (items.user) {
                    this.user = items.user;
                } else {
                    this.noResult = true;
                }
                this.roles= items.roles;
  


            }, //Bind to view
            err => {
                this.requestError = true;
                // Log errors if any
                this.rootService.toast.showErrorCode(err.code);
            });
    }
    getInfo() {
        if (!this.user) {
            this.user = {
                active: false,
  
            };
        }
        this.requestError = false;
        this.noResult = false;
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        this.requestXHR = this.userService.getInfo()
            .subscribe(
            items => {
                this.roles= items.roles;
  


            }, //Bind to view
            err => {
                this.requestError = true;
                // Log errors if any
                this.rootService.toast.showErrorCode(err.code);
            });
    }
    deleteUser() {
        this.confirmationService.confirm({
            message: this.translate.instant('form.common.deleteQ', { 'item': this.translate.instant('ctrl.user.view.header.one') }),
            header: this.translate.instant('form.common.delete'),
            icon: 'fa fa-trash',
            accept: () => {
                this.userService.delete(this.user._id)
                    .subscribe(
                    items => {
                        this.rootService.toast.showSuccess(this.translate.instant('form.common.deleteItem', { 'item': this.translate.instant('ctrl.user.view.header.one') }));
                        this.formSubmited.emit(this.operation);

                    }, //Bind to view
                    err => {
                        this.rootService.toast.showErrorCode(err.code);
                    });
            }
        });
    }
    
    removeArray(array, index) {
        array.splice(index, 1);
    }
    submitForm() {
        var formElement = this.formElement;
        var form = this.form;
        if (form.invalid) {
            var firstElement = formElement.nativeElement.querySelector('.ng-invalid');
            var focusElement = firstElement.querySelector('.focusV');
            if (focusElement) {
                focusElement.focus();
            }
            return;
        }
        if(this.submittingForm){
            return;
        }
        this.submittingForm=true;
        if (this.operation == 'create' || this.operation == 'clone') {
            this.userService.create(this.user).subscribe(items => {
                this.rootService.toast.showSuccess(this.translate.instant('form.common.createItem', { 'item': this.translate.instant('ctrl.user.view.header.one') }));
                this.submittingForm=false;
                this.formSubmited.emit(this.operation);
            }, err => {
                this.rootService.toast.showErrorCode(err.code);
                this.submittingForm=false;
            });
        } else if (this.operation == 'update') {
            this.userService.update(this.id, this.user).subscribe(items => {
                this.rootService.toast.showSuccess(this.translate.instant('form.common.updateItem', { 'item': this.translate.instant('ctrl.user.view.header.one') }));
                this.submittingForm=false;
                this.formSubmited.emit(this.operation);
            },err => {
                this.rootService.toast.showErrorCode(err.code);
                this.submittingForm=false;
            });
        }
    }

    refreshRequest() {
        if (this.operation == 'create') {
            this.getInfo();
        } else if (this.operation == 'clone') {
            this.getClone(this.id);
        } else {
            this.getUser(this.id);
        }
    }
    ngOnInit() {
        if (typeof this.id !== 'undefined' && this.id != null) {
            if (this.operation == 'clone') {
                this.getClone(+this.id);
            } else {
                this.getUser(+this.id);
            }
        } else if(this.operation == 'create'){
            this.getInfo();
        }


    }
    ngOnDestroy() {
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        if (this.routeEvent) {
            this.routeEvent.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/module/user/user/user.component.ts